/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
  whenHasPermission,
} from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { ContactDetailsEmployee } from '../../resources/model/contact-details-employee.model';
import { ContactDetailsEmployeeCommonFormState } from '../contact-details-employee-common-tab/contact-details-employee-common-form.service';
import {
  ContactDetailsSharedCommunicationListFormState,
  ContactDetailsSharedCommunicationListFormStateFactory,
} from '../contact-details-shared-communication-list-tab/contact-details-shared-communication-list-form.service';
import {
  ContactDetailsSharedCustomFieldsFormState,
  ContactDetailsSharedCustomFieldsFormStateFactory,
} from '../contact-details-shared-custom-fields-tab/contact-details-shared-custom-fields-form.service';

import {
  ContactDetailsSharedTermsPayeeFormState,
  ContactDetailsSharedTermsPayeeFormStateFactory,
} from '../contact-details-shared-terms-tab/contact-details-shared-terms-payee-form.service';

@Injectable()
export class ContactDetailsEmployeeFormDelegator extends FormState<ContactDetailsEmployee> {
  termsForm: ContactDetailsSharedTermsPayeeFormState;
  customFieldsForm: ContactDetailsSharedCustomFieldsFormState;
  communicationForm: ContactDetailsSharedCommunicationListFormState;

  constructor(schemaFactory: BuilderFormSchemaFactory,
              private commonForm: ContactDetailsEmployeeCommonFormState,
              termsFormFactory: ContactDetailsSharedTermsPayeeFormStateFactory,
              customFieldsFormFactory: ContactDetailsSharedCustomFieldsFormStateFactory,
              communicationFormFactory: ContactDetailsSharedCommunicationListFormStateFactory) {
    super(schemaFactory);
    this.termsForm = termsFormFactory.create();
    this.customFieldsForm = customFieldsFormFactory.create();
    this.communicationForm = communicationFormFactory.create();
  }

  build(employee: ContactDetailsEmployee): void {
    this.commonForm.build(employee.common);
    this.termsForm.build(employee.terms);
    this.communicationForm.build(employee.communication);
    this.customFieldsForm.build(employee.customFields);

    this.initSchema(employee);
    this.setChildForm('common', this.commonForm);
    this.setChildForm('terms', this.termsForm);
    this.setChildForm('communication', this.communicationForm);
    this.setChildForm('customFields', this.customFieldsForm);
  }

  protected buildSchema(_: ContactDetailsEmployee, { root, native }: FormStateSchema): FormRootSchema {
    return root({
      enabled: whenHasPermission(BuilderPermission.Contacts.Employee.CREATE_EDIT),
      children: {
        common: native(this.commonForm.group),
        terms: native(this.termsForm.group),
        communication: native(this.communicationForm.group),
        customFields: native(this.customFieldsForm.group),
      },
    });
  }
}
